import React,{useEffect} from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEllipsisVertical  } from '@fortawesome/free-solid-svg-icons';
import { toast } from 'react-toastify';
import { useSelector } from "react-redux";

import { base64Encode, getShortForm, formatDate } from '../../../../component/common/Helper';
import {MenuComponent} from '../../../../../_template/assets/ts/components/MenuComponent';
import StatusChangePopup from './StatusChangePopup';
import CommonTooltip from '../../../../component/common/CommonTooltip';

import ActionPopup from './ActionPopup';
const BotList = (props) => {
    const api_base_url = process.env.REACT_APP_API_URL;
    const bot_url = process.env.REACT_APP_BOT_URL;
    const {
        bot_id, 
        bot_name, 
        channel_name, 
        language, 
        bot_status,
        sass_id,
        bot_avtar,
        active_status,
        bot_hook_type,
        bot_hook,
        bot_description,
        updated_at,
        bot_status_error_msg,
        widget_id
    } = props;

    const assignPermission = useSelector((state) => state.store_permission_data.permissionArr);
    let botScript ='';
    let scriptLabel = '';
    if(bot_hook_type === 'default_widget'){
        let widgetVal = '';
        if(widget_id){
            widgetVal = `widget="${base64Encode(widget_id)}"`
        }
        scriptLabel = 'Integration Script'
        botScript = `<script src="${api_base_url+''+bot_url}" bizcode="${base64Encode(sass_id)}" auth="${base64Encode(bot_id)}" id="secured" ${widgetVal}></script>`;
    }
    else if(bot_hook_type === 'custom_hook'){
        scriptLabel = 'Hook URL'
        botScript = bot_hook
    }
   
    const copyHandler = async (param) => {
        await navigator.clipboard.writeText(param);
        toast.success("Script copied successfully");
    };

    let symbolVal = '';
    if(Object.keys(bot_avtar).length > 0){
        symbolVal = <img src={bot_avtar.full_path} alt="image" />
    }
    else{
        symbolVal = <span className="symbol-label fs-2 fw-bold text-primary text-uppercase">
            {getShortForm(bot_name)}
        </span>
    }

    const statusMap = {
        draft: { color: 'warning', msg: 'Draft' },
        success: { color: 'success', msg: 'Live' },
        live: { color: 'success', msg: 'Live' },
        failed: { color: 'danger', msg: 'Failed' },
        complete: { color: 'success', msg: 'Complete' },
        processing: { color: 'info', msg: 'Processing' },
    };
    const defaultStatus = { color: 'secondary', msg: 'Unknown' };
    const { color: statusColor, msg: statueMsg } = statusMap[bot_status] || defaultStatus;
   

    const viewDetailsOnClickHandler = () => {
        props.drawerIsOpen({type:'open', bot_id:bot_id, bot_name: bot_name})
    }
    const virtualAgentUpdateOnClickHandler = () => {
        props.botUpdateOnClick(bot_id)
    }
    const virtualAgentDeleteOnClickHandler = () => {
        props.botDeleteOnClick(bot_id)
    }
    const virtualAgentScriptCopyOnClickHandler = () => {
        copyHandler(botScript)
    }
    // ------ view log on click handler ----- //
    const viewLogOnClickHandler = () => {
        props.viewLogOnClick(bot_id)
    }
    // ---- status change ----- //
    const statusChangeOnClickHandler = (statusType) => {
        props.botStatusUpdateOnChange(bot_id, statusType)
    }
    // ---- download csv ---- //
    const downloadCsvOnClickHandler = () => {
        props.downloadCsvOnClick(bot_id)
    }
    useEffect(() => {
        setTimeout(() => {
            MenuComponent.reinitialization();
        }, 500);
    }, []);

    return (
        <>
            <tr>
                <td>
                    <div className="d-flex">
                        <div className="symbol symbol-50px me-3">
                            {symbolVal}
                        </div>
                        <div className="d-flex justify-content-start flex-column">
                            <a className="text-gray-800 fw-bold mb-1 fs-6">
                                {bot_name}
                            </a>
                            <span className="text-gray-400 fw-semibold d-block fs-7">
                                <span className='badge badge-light fs-base'>
                                    {bot_id}
                                </span>
                            </span>
                        </div>
                    </div>
                </td>
                <td className="">
                    <span className="text-gray-600 fs-6">
                        {
                            bot_description &&
                            <>
                                {bot_description.length > 50
                                    ? <>
                                        {bot_description.slice(0, 50)}...
                                        <span 
                                            className='cursor-pointer fw-semibold text-gray-400 fs-7'
                                            data-tooltip-id="common_tooltip" 
                                            data-tooltip-content={bot_description}
                                        >
                                            View more
                                        </span>
                                        <CommonTooltip
                                            id="common_tooltip"
                                            style= {{ backgroundColor: "black", color: "white", fontSize:"14px" }}
                                            place="top"
                                            float={true}
                                        />
                                    </>
                                    : bot_description
                                }
                            </>
                        }
                    </span>
                </td>
                <td className="">
                    <span
                        className="text-gray-600 fw-bold fs-6 cursor-pointer"
                        data-sai-menu-trigger='click'
                        data-sai-menu-placement='bottom-end'
                        data-sai-menu-flip='top-end'
                    >
                        {
                            bot_status ?
                            <span className={`badge badge-light-${statusColor} fs-base`}>
                                {statueMsg}
                            </span>
                            :''
                        }
                    </span>
                    {
                        assignPermission.allow_change_permission === 'Y' &&  bot_status != 'processing' &&
                        <>
                            <StatusChangePopup
                                statusChangeOnClick={statusChangeOnClickHandler}
                                botCurrentStatus={bot_status}
                                botStatusErrorMsg={bot_status_error_msg}
                            />
                        </>
                    }
                </td>
                <td className="">
                    <span className="text-gray-600 fw-bold fs-6">
                        {channel_name?.label}
                    </span>
                </td>
                <td className="">
                    <span className="text-gray-600 fw-bold fs-6">
                        {language?.label}
                    </span>
                </td>
                <td className="">
                    <span className="text-gray-600 fw-bold fs-6">
                        {formatDate(updated_at)}
                    </span>
                </td>
                
                <td className="d-flex" style={{borderBottom: 'none'}}>
                    <a 
                        className="btn btn-sm btn-icon btn-light-primary"
                        data-sai-menu-trigger='click'
                        data-sai-menu-placement='bottom-end'
                        data-sai-menu-flip='top-end'
                    >
                        <FontAwesomeIcon icon={faEllipsisVertical} className='fs-4'/>
                    </a>
                    <ActionPopup
                        widget_type={bot_hook_type}
                        viewDetailsOnClick={viewDetailsOnClickHandler}
                        virtualAgentUpdateOnClick={virtualAgentUpdateOnClickHandler}
                        virtualAgentDeleteOnClick={virtualAgentDeleteOnClickHandler}
                        virtualAgentScriptCopyOnClick={virtualAgentScriptCopyOnClickHandler}
                        downloadCsvOnCLick={downloadCsvOnClickHandler}
                        viewLogOnClick={viewLogOnClickHandler}
                    />
                </td>
            </tr>
        </>
    )
}

export default BotList